/**
 * Interface for runtime configuration
 */
interface RunConfig {
  baseUrl: string;
  environment: string;
  frumBaseUrl: string;
  ramAssistantUrl: string;
}

/**
 * Interface for OIDC configuration
 */
interface OidcConfig {
  clientId: string;
  issuer: string;
  redirectUri: string;
  scopes: string[];
  pkce: boolean;
  disableHttpsCheck: boolean;
}

/**
 * Generates RAM Assistant URL with all required parameters from window configuration
 * @param brand - The selected brand
 * @param requesterApplication - The requester application name
 * @returns Generated URL string for RAM Assistant
 */
export const generateRamAssistantUrl = (
  brand: string,
  requesterApplication: string,
): string => {
  // Get configuration from window objects
  const runConfig: RunConfig = window['runConfig'];
  const oidcConfig: OidcConfig = window['oidc'];

  if (!runConfig || !oidcConfig) {
    console.warn('Runtime configuration not found, using fallback URL');
    return `${runConfig?.ramAssistantUrl || ''}?brand=${brand}&requesterApplication=${requesterApplication}`;
  }

  // Extract required values
  const { baseUrl, environment, frumBaseUrl, ramAssistantUrl } = runConfig;

  const { clientId, issuer, scopes, pkce, disableHttpsCheck } = oidcConfig;

  // Convert scopes array to comma-separated string
  const scopesString = scopes.join(',');

  // Build URL with all parameters
  const urlParams = new URLSearchParams({
    brand,
    requesterApplication,
    baseUrl,
    environment,
    frumBaseUrl,
    ramAssistantUrl,
    clientId,
    issuer,
    scopes: scopesString,
    pkce: pkce.toString(),
    disableHttpsCheck: disableHttpsCheck.toString(),
  });

  return `${ramAssistantUrl}?${urlParams.toString()}`;
};
